import { FlexColumn } from '@editor/components/utilities/layouts';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ContactSupportLink = styled.a`
  color: ${themeStyle.varBlueMain};
  text-decoration-color: ${themeStyle.varBlueMain};
`;

export const PaymentFormContainer = styled(FlexColumn)`
  position: relative;

  width: 100%;
  min-height: 64px;
`;
